import { render, staticRenderFns } from "./inputTypeNumber.vue?vue&type=template&id=51d93c16&scoped=true"
import script from "./inputTypeNumber.vue?vue&type=script&lang=js"
export * from "./inputTypeNumber.vue?vue&type=script&lang=js"
import style0 from "./inputTypeNumber.vue?vue&type=style&index=0&id=51d93c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d93c16",
  null
  
)

export default component.exports